module.exports = __webpack_public_path__ + "img/vi.8198fa0c.png";